<template>
  <div id="app">
    <header class="home-header wrap" v-if="!(ishide=='1')">
        <!-- <span class="logo-name">{{ $t("header.lang") }}</span> -->
        
      <router-link  to="home">
        <img src='./assets/logo.jpg' class="logo">
      </router-link>
        <div class="header-search">
            <router-link v-if="$i18n.locale == 'en'" tag="span" class="search-title" to="./search?from=home&ishide=1">please enter keyword</router-link>
            <router-link v-else  tag="span" class="search-title" to="./search?from=home&ishide=1">请输入产品关键字</router-link>
        </div>
        <img  v-if="$i18n.locale == 'en'" class="language" src="./assets/cn.png" @click="changeLanguage()">
        <img v-else class="language" src="./assets/en.png" @click="changeLanguage()">
        <!-- <router-link class="login" tag="span" to="./login" v-if="!isLogin">登录</router-link>
        <router-link class="login" tag="span" to="./user" v-else>
          <van-icon name="manager-o" />
        </router-link> -->
    </header>
    <nav-bar v-if="!(ishide=='1')"></nav-bar>
    <transition  v-if="!ishide" :name="transitionName">
      <router-view class="router-view" />
    </transition>
    <transition v-else :name="transitionName">
      <router-view class="router-view view-hide" />
    </transition>
  </div>
</template>

<script>
import navBar from './components/NavBar'
    var _self 
export default {
  data () {
    return {
      transitionName: 'slide-left',
      ishide:this.$route.query.ishide
    }
  },
  components: {
    navBar
  },
  async mounted(){
    this.ishide = this.$route.query.ishide
    _self=this
  },
  watch: {
    $route (to, from) {
    _self.ishide=to.query.ishide
    // alert(!_self.ishide)
    //   _self.ishide=to.query.ishide
    // alert(!_self.ishide)
      // 有主级到次级
      if (to.meta.index > from.meta.index) {
        // 向左滑动
        this.transitionName = 'slide-left'
      } else if (to.meta.index < from.meta.index) {
        // 由次级到主级
        this.transitionName = 'slide-right'
      } else {
        // 同级无过渡效果
        this.transitionName = ''
      }
    }
  },
  methods:{
    changeLanguage() {
      this.$i18n.locale == "zh"
        ? (this.$i18n.locale = "en")
        : (this.$i18n.locale = "zh"); //设置中英文模式
      localStorage.setItem("languageSet", this.$i18n.locale); //将用户设置存储到localStorage以便用户下次打开时使用此设置
      //window.location.href="/"
    },
  }
}
</script>

<style lang="less" scoped >
  @import './style/mixin';
  .logo-name{
      color: #000;
    font-weight: bold;
  }
  .logo{
    width: 100px;
    height: 40px;
    margin-top: 5px;
  }
  .language{
    margin-top: 10px;
    margin-bottom: 9px;
    height: 30;
    width: 30;
    text-align: center;
    vertical-align: middle;
  }
  .home-header {
      position: fixed;
      left: 0;
      top: 0;
      .wh(100%, 50px);
      .fj();
      line-height: 50px;
      padding: 0 15px;
      .boxSizing();
      font-size: 15px;
      color: #fff;
      z-index: 10000;
      background: #fff;
        border-bottom: 1PX solid #e9e9e9;
      .nbmenu2 {
        color: @primary;
      }
      &.active {
        background: @primary;
        .nbmenu2 {
          color: #fff;
        }
      }

      .header-search {
          display: flex;
          .wh(44%, 20px);
          line-height: 20px;
          margin: 10px 0;
          padding: 5px 10px;
          color: #232326;
          background: rgba(0, 0, 0, 0.1);
          border-radius: 20px;
          .app-name {
              padding: 0 10px;
              color: @primary;
              font-size: 20px;
              font-weight: bold;
              border-right: 1px solid #666;
          }
          .icon-search {
              padding: 0 10px;
              font-size: 17px;
          }
          .search-title {
              font-size: 12px;
              color: #666;
              line-height: 21px;
          }
      }
      .icon-iconyonghu{
        color: #fff;
        font-size: 22px;
      }
  }
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
.router-view {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  margin-top: 50px;
  margin-bottom: 50px;
  padding-bottom: 50px;;
  -webkit-overflow-scrolling: touch;
}
.router-view-hide {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  height: 100%;
  will-change: transform;
  transition: all 500ms;
  position: absolute;
  backface-visibility: hidden;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/App.vue